import { useRef, useCallback } from 'react';

const useAbortableQuery = () => {
  const activeRequestRef = useRef(0);

  const runQuery = useCallback(async queryFn => {
    const requestId = ++activeRequestRef.current;
    const result = await queryFn();
    if (requestId !== activeRequestRef.current) {
      return { aborted: true, data: null };
    }
    return { aborted: false, data: result };
  }, []);

  const cancel = useCallback(() => {
    activeRequestRef.current++;
  }, []);

  return { runQuery, cancel };
};

export default useAbortableQuery;
